import React from 'react';
import PropTypes from 'prop-types';
import { GeometryUtils } from '../../utils/export';
import Ruler from './ruler';
import If from '../../utils/react-if';
import * as SharedStyle from '../../shared-style';

var STYLE_TEXT = {
  textAnchor: "middle",
  fontSize: "12px",
  fontFamily: "'Courier New', Courier, monospace",
  pointerEvents: "none",
  fontWeight: "bold",

  //http://stackoverflow.com/questions/826782/how-to-disable-text-selection-highlighting-using-css
  WebkitTouchCallout: "none", /* iOS Safari */
  WebkitUserSelect: "none", /* Chrome/Safari/Opera */
  MozUserSelect: "none", /* Firefox */
  MsUserSelect: "none", /* Internet Explorer/Edge */
  userSelect: "none"
};

export default function Pipe(_ref) {
  var pipe = _ref.pipe,
      layer = _ref.layer,
      scene = _ref.scene,
      catalog = _ref.catalog,
      isDesktop = _ref.isDesktop;


  var vertex0 = layer.vertices.get(pipe.vertices.get(0));
  var vertex1 = layer.vertices.get(pipe.vertices.get(1));

  if (vertex0.id === vertex1.id || GeometryUtils.samePoints(vertex0, vertex1)) return null; //avoid 0-length lines

  var elevationItems = [];
  var currentlayerElevationItems = [];
  var floorsArr = [];
  var activeFloors = [];
  var minFloorID = '';
  var hasElevationItemsOnDifferentFloors = false;

  var deltaX = 0;
  var deltaY = 0;

  if (pipe.floorID) {
    var layers = scene.get('layers');

    if (layers) {
      layers.forEach(function (currentLayer) {
        var layerItems = currentLayer.get('items').toJS();

        if (layerItems) {
          for (var item in layerItems) {
            var itemObj = layerItems[item];

            if (itemObj && (itemObj.name === 'Elevation Sign' || itemObj.type === 'elevation-sign')) {
              var currentLayerId = currentLayer.get('id');

              if (currentLayerId === layer.id) {
                currentlayerElevationItems.push(itemObj);
              } else {
                elevationItems.push(itemObj);
              }
            }
          }
        }
      });

      if (currentlayerElevationItems.length > 0 || elevationItems.length > 0) {
        var allElevationItems = currentlayerElevationItems.concat(elevationItems);

        var _loop = function _loop(elItem) {
          var elevationItemOnDiffFloor = allElevationItems.find(function (i) {
            return i.floorID !== elItem.floorID;
          });

          if (elevationItemOnDiffFloor) {
            hasElevationItemsOnDifferentFloors = true;
            return 'break';
          }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = allElevationItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var elItem = _step.value;

            var _ret = _loop(elItem);

            if (_ret === 'break') break;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (hasElevationItemsOnDifferentFloors) {
        var floors = scene.get('floors').toJS();

        if (floors) {
          for (var floor in floors) {
            floorsArr.push(floors[floor]);
          }
        }

        if (floorsArr.length > 0) {
          floorsArr.forEach(function (floor) {
            var found = elevationItems.find(function (i) {
              return i.floorID === floor.id;
            });

            if (!found) {
              found = currentlayerElevationItems.find(function (i) {
                return i.floorID === floor.id;
              });
            }

            if (found) {
              activeFloors.push(floor);
            }
          });

          if (activeFloors.length > 0) {
            var minFloor = activeFloors.reduce(function (prev, current) {
              return prev.elevation < current.elevation ? prev : current;
            });

            if (minFloor) {
              minFloorID = minFloor.id;
            }
          }
        }

        if (minFloorID) {
          var pipeFloorId = pipe.floorID;
          var currentElevationItem = currentlayerElevationItems.find(function (i) {
            return i.floorID === pipeFloorId;
          });

          if (!currentElevationItem) {
            currentElevationItem = elevationItems.find(function (i) {
              return i.floorID === pipeFloorId;
            });
          }

          var minFloorElevationItem = currentlayerElevationItems.find(function (i) {
            return i.floorID === minFloorID;
          });

          if (!minFloorElevationItem) {
            minFloorElevationItem = elevationItems.find(function (i) {
              return i.floorID === minFloorID;
            });
          }

          if (minFloorElevationItem && currentElevationItem) {
            if (minFloorID !== pipeFloorId) {

              // deltaX = currentElevationItem.x - minFloorElevationItem.x;
              // deltaY = currentElevationItem.y - minFloorElevationItem.y;

              var vertex0x = vertex0.x;
              var vertex0y = vertex0.y;

              var vertex1x = vertex1.x;
              var vertex1y = vertex1.y;

              var _deltaX = vertex0x - currentElevationItem.x;
              var _deltaY = vertex0y - currentElevationItem.y;

              var displacedX = minFloorElevationItem.x + _deltaX;
              var displacedY = minFloorElevationItem.y + _deltaY;

              vertex0 = vertex0.setIn(['x'], displacedX);
              vertex0 = vertex0.setIn(['y'], displacedY);

              _deltaX = vertex1x - currentElevationItem.x;
              _deltaY = vertex1y - currentElevationItem.y;

              displacedX = minFloorElevationItem.x + _deltaX;
              displacedY = minFloorElevationItem.y + _deltaY;

              vertex1 = vertex1.setIn(['x'], displacedX);
              vertex1 = vertex1.setIn(['y'], displacedY);
            }
          }
        }
      }
    }
  }

  var _vertex = vertex0,
      x1 = _vertex.x,
      y1 = _vertex.y;
  var _vertex2 = vertex1,
      x2 = _vertex2.x,
      y2 = _vertex2.y;

  var reversedVertices = false;

  if (x1 === x2) {
    // 2d verticle pipes
    if (y1 > y2) {
      var _vertex3 = vertex1; // top to bottom drawing

      x1 = _vertex3.x;
      y1 = _vertex3.y;
      var _vertex4 = vertex0;
      x2 = _vertex4.x;
      y2 = _vertex4.y;

      reversedVertices = true;
    }
  } else if (y1 === y2) {
    // 2d horizontal pipes
    if (x1 > x2) {
      var _vertex5 = vertex1; // right to left drawing

      x1 = _vertex5.x;
      y1 = _vertex5.y;
      var _vertex6 = vertex0;
      x2 = _vertex6.x;
      y2 = _vertex6.y;
    }
  } else {
    // with angle
    if (x1 > x2 && y1 > y2) {
      var _vertex7 = vertex1;
      x1 = _vertex7.x;
      y1 = _vertex7.y;
      var _vertex8 = vertex0;
      x2 = _vertex8.x;
      y2 = _vertex8.y;
    }

    if (x1 > x2 && y1 < y2) {
      var _vertex9 = vertex1;
      x1 = _vertex9.x;
      y1 = _vertex9.y;
      var _vertex10 = vertex0;
      x2 = _vertex10.x;
      y2 = _vertex10.y;
    }
  }

  var length = GeometryUtils.pointsDistance(x1, y1, x2, y2);
  var angle = GeometryUtils.angleBetweenTwoPointsAndOrigin(x1, y1, x2, y2);

  var renderedHoles = pipe.holes.map(function (holeID) {
    var hole = layer.holes.get(holeID);
    var startAt = length * (reversedVertices ? 1 - hole.offset : hole.offset);
    var renderedHole = catalog.getElement(hole.type).renderAxonomertic ? catalog.getElement(hole.type).renderAxonomertic(hole, layer, scene, angle) : null;
    return React.createElement(
      'g',
      {
        key: holeID,
        transform: 'translate(' + startAt + ', 0)',
        'data-element-root': true,
        'data-prototype': hole.prototype,
        'data-id': hole.id,
        'data-selected': hole.selected,
        'data-layer': layer.id
      },
      renderedHole,
      React.createElement(
        If,
        { condition: hole.selected && hole.properties.get('width') !== undefined },
        React.createElement(
          'g',
          { 'data-element-root': true,
            'data-prototype': hole.prototype,
            'data-id': hole.id,
            'data-selected': hole.selected,
            'data-layer': layer.id,
            'data-part': 'resize-anchor-width'
          },
          React.createElement('circle', { cx: hole.getIn(['properties', 'width', 'length']) / 2, cy: '0',
            r: isDesktop ? SharedStyle.CONTROL_POINT_RADIUS : SharedStyle.CONTROL_POINT_RADIUS_BIG, style: SharedStyle.CONTROL_POINT_STYLE }),
          React.createElement(
            'g',
            { transform: 'translate(' + (hole.getIn(['properties', 'width', 'length']) / 2 - (isDesktop ? 6 : 12)) + ' ' + (isDesktop ? -5 : -10) + ')\n            ' + (isDesktop ? 'scale(1, 1)' : 'scale(2, 2)') },
            React.createElement('polyline', { points: '1,5 4,8 4,2 1,5', style: SharedStyle.CONTROL_POINT_ARROW_STYLE }),
            React.createElement('polyline', { points: '1,5 4,8 4,2 1,5', transform: 'translate(12,0) rotate(180,0,5)', style: SharedStyle.CONTROL_POINT_ARROW_STYLE })
          )
        )
      )
    );
  });

  //let layerAltitude = layer.altitude;
  var floorID = pipe.floorID;
  var floorAltitude = 0;

  if (floorID) {
    floorAltitude = scene.getIn(['floors', floorID, 'elevation']);
  }

  var pipeAltitude = pipe.getIn(['properties', 'altitude', 'length']);
  var thickness = pipe.getIn(['properties', 'thickness', 'length']);
  var pipeText = pipe.getIn(['properties', 'text']);

  var diameter = pipe.getIn(['properties', 'diameter', 'length']);
  var diameterText = diameter ? ', \u0424' + diameter : '';

  var half_thickness = thickness / 2;
  var renderedPipe = catalog.getElement(pipe.type).render2D(pipe, layer);
  var pipeLength = length.toFixed(2) + ' ' + scene.unit;

  var renderedRuler = pipe.selected ? React.createElement(
    'g',
    null,
    React.createElement(Ruler, { unit: scene.unit, length: length, transform: 'translate(0, ' + (half_thickness + 10) + ' )' }),
    React.createElement(
      'text',
      { x: length / 2, y: '-30', transform: 'scale(1, -1)', style: STYLE_TEXT },
      pipeText
    )
  ) : React.createElement(
    'g',
    null,
    React.createElement(
      'text',
      { x: length / 2, y: '-20', transform: 'scale(1, -1)', style: STYLE_TEXT },
      pipeLength,
      diameterText
    ),
    React.createElement(
      'text',
      { x: length / 2, y: '-35', transform: 'scale(1, -1)', style: STYLE_TEXT },
      pipeText
    ),
    pipeAltitude ? React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M' + length / 2 + ' -35 L' + length / 2 + ' -55 M' + length / 2 + ' -40 L' + (length / 2 + 60) + ' -40 M' + length / 2 + ' -40 L' + (length / 2 - 5) + ' -40 M' + length / 2 + ' -35 L' + (length / 2 - 5) + ' -40',
        stroke: '#000000', fill: '#000000',
        transform: 'scale(1, -1) skewX(0) translate(60, 20)'
      }),
      React.createElement(
        'text',
        { x: length / 2 + 25, y: '-45', style: STYLE_TEXT, transform: 'scale(1, -1) translate(60, 20)' },
        pipeAltitude > 0 ? '+' + pipeAltitude.toFixed(2) : '-' + pipeAltitude.toFixed(2)
      )
    ) : null
  );

  return React.createElement(
    'g',
    { transform: 'translate(0, ' + (floorAltitude + pipeAltitude) + ')' },
    React.createElement(
      'g',
      { transform: 'translate(-460, ' + (minFloorID ? '0' : '-50') + ') skewX(30)' },
      React.createElement(
        'g',
        {
          transform: 'translate(' + x1 + ', ' + y1 + ') rotate(' + angle + ', 0, 0)',
          'data-element-root': true,
          'data-prototype': pipe.prototype,
          'data-id': pipe.id,
          'data-selected': pipe.selected,
          'data-layer': layer.id,
          style: pipe.selected ? { cursor: 'move' } : {}
        },
        renderedRuler,
        renderedPipe,
        renderedHoles
      )
    )
  );
}

Pipe.propTypes = {
  pipe: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  scene: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
  isDesktop: PropTypes.bool.isRequired
};